module.exports = __webpack_public_path__ + "img/64-bit.e7f037fb.png";